<template>
  <section class="landing landingbb purchase-sale">
    <div class="overlay">
      <div class="container">
        <div class="landing-content subpage-heading-center">
          <span class="mini-title">{{ $t('footer.contact.mini-title') }} </span>
          <span class="heading-title">{{ $t('footer.contact.title') }} </span>
          <hr>
          <span class="paragraph">{{ $t('footer.contact.content') }}</span>
        </div>
      </div>
    </div>
  </section>
  <section class="form contact-form">
    <div class="container">
      <form class="form-grid" @submit.prevent="handleSubmit">
          <div class="input-container">
            <label for="fname">{{ $t('contactPage.fname') }} * :</label>
            <input type="text" id="fname" name="fname" v-model="formData.fname" @input="validateField('fname')">
            <p class="error-message" v-if="errors.fname">{{ errors.fname }}</p>
          </div>
          <div class="input-container">
            <label for="lname">{{ $t('contactPage.lname') }} * :</label>
            <input type="text" id="lname" name="lname" v-model="formData.lname" @input="validateField('lname')">
            <p class="error-message" v-if="errors.lname">{{ errors.lname }}</p>
          </div>
          <div class="input-container">
            <label for="phone">{{ $t('contactPage.phone') }} * :</label>
            <input type="text" id="phone" name="phone" v-model="formData.phone" @input="validateField('phone')">
            <p class="error-message" v-if="errors.phone">{{ errors.phone }}</p>
          </div>
          <div class="input-container">
            <label for="email">{{ $t('contactPage.email') }} * :</label>
            <input type="text" id="email" name="email" v-model="formData.email" @input="validateField('email')">
            <p class="error-message" v-if="errors.email">{{ errors.email }}</p>
          </div>
          <div class="textarea-container">
            <label for="message">{{ $t('contactPage.message') }} * :</label>
            <textarea name="message" v-model="formData.message" @input="validateField('message')"></textarea>
            <p class="error-message" v-if="errors.message">{{ errors.message }}</p>
          </div>
          <button type="submit">{{ $t('contactPage.submit') }}</button>
      </form>
      <div class="contact-details">
        <div class="cards-contact-details">
          <div class="card-contact">
            <span class="icon-contact"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
            <span class="paragraph-contact">{{ $t('contactPage.callUs') }}</span>
            <a href="tel:0629239966">0629239966</a>
            <span class="paragraph-contact p-c-p">{{ $t('contactPage.callUsHours') }}</span>
          </div>
          <div class="card-contact">
            <span class="icon-contact"><i class="fa fa-envelope" aria-hidden="true"></i></span>
            <span class="paragraph-contact">{{ $t('contactPage.emailUs') }}</span>
            <a href="mailto:info@auto-moto-sales.ch">info@auto-moto-sales.ch</a>
          </div>
          <div class="card-contact">
            <span class="icon-contact"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
            <span class="paragraph-contact">AS Auto Moto Sales GmbH</span>
            <span class="paragraph-contact p-c-p">Haldenstr. 72</span>
            <span class="paragraph-contact p-c-p">4900 Langenthal</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import API_BASE_URL from "@/config";

export default {
  name: 'ContactPage',
  data() {
    return {
      formData: {
        fname: "",
        lname: "",
        phone: "",
        email: "",
        message: ""
      },
      errors: {},
    };
  },
  methods: {
    async validateField(field) {
      try { 
        const response = await axios.post(`${API_BASE_URL}/contact/validate`, {
          field,
          value: this.formData[field],
          lang: this.$i18n.locale
        });

        if (response.data.success) {
          this.errors[field] = "";
          return true; // Field is valid
        }
      } catch (error) {
        this.errors[field] = error.response?.data?.errors[0]?.msg || "Validation error";
        return false; // Field has error
      }
    }
    ,
    async handleSubmit() {
      try {
        this.errors = {}; // Clear previous errors
        const fieldsToValidate = Object.keys(this.formData);

        // Validate all fields and collect results
        const validationResults = await Promise.all(
          fieldsToValidate.map(async (field) => {
            const isValid = await this.validateField(field);
            return isValid;
          })
        );

        // If any field is invalid, stop submission
        if (validationResults.includes(false)) {
          alert(this.$t("autopurchaseform.labels.formErrors"));
          return;
        }
          
        // Submit the form if validation passes
        const response = await axios.post(`${API_BASE_URL}/contact/submit`, this.formData, {
          headers: { "Accept-Language": this.$i18n.locale }
        });

        if (response.status === 200) {
          sessionStorage.setItem("formSubmitted", "true");
          this.$router.push({ name: `SuccessPage${this.$i18n.locale.toUpperCase()}` });
        }
      } catch (error) {
        if (error.response?.status === 400) {
          this.errors = {};
          error.response.data.errors.forEach(err => {
            this.errors[err.field] = err.msg;

          });
        } else {
          console.error("Unexpected Error:", error);
        }
      }
    }

  }
};
</script>

<style scoped></style>
